<template>
  <div class="stars" :style="composedStyle">
    <i v-for="(v, index) in list" :key="index" class="iconfont" :class="{ 'icon-star-full': v === 1, 'icon-star-half': v === 0.5, 'icon-star-empty': v === 0}" :style="{ 'font-size': `${remSize}rem`, 'margin-right': `${index === 4 ? 0 : composedMargin}px`}" />
  </div>
</template>

<script>
import Util from '../lib/util';

export default {
  name: 'Stars',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: '#f60',
    },
    margin: {
      type: Number,
      default: -1,
    },
    customStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    list() {
      let count = Number.parseFloat(this.value);
      if (Number.isNaN(count)) {
        switch (this.value) {
          case 'one':
            return [1, 0, 0, 0, 0];
          case 'one-five':
            return [1, 0.5, 0, 0, 0];
          case 'two':
            return [1, 1, 0, 0, 0];
          case 'two-five':
            return [1, 1, 0.5, 0, 0];
          case 'three':
            return [1, 1, 1, 0, 0];
          case 'three-five':
            return [1, 1, 1, 0.5, 0];
          case 'four':
            return [1, 1, 1, 1, 0];
          case 'four-five':
            return [1, 1, 1, 1, 0.5];
          case 'five':
            return [1, 1, 1, 1, 1];
          default:
            return [];
        }
      } else {
        const result = [];
        for (let i = 0; i < 5; i++) {
          result.push(count >= 1 ? 1 : (count === 0.5 ? 0.5 : 0));
          count--;
        }
        return result;
      }
    },
    composedStyle() {
      return Object.assign({}, { 'line-height': `${Util.px2rem(this.size)}rem`, color: this.color }, this.customStyle);
    },
    composedMargin() {
      return this.margin > 0 ? this.margin : this.size / 8;
    },
    remSize() {
      return Util.px2rem(this.size);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.stars {
  display: inline-block;
  margin-top: 0;
  vertical-align: top;
}
</style>
